import { render, staticRenderFns } from "./LeadBoxFollowUp.vue?vue&type=template&id=102f352e&"
import script from "./LeadBoxFollowUp.vue?vue&type=script&lang=js&"
export * from "./LeadBoxFollowUp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports